<template>
  <div class="container-fluid">
    <main class="expired-get-started-main">
      <div class="row">
        <div class="col-2 cloud-l">
          <span class="waves wave1"></span>
        </div>
        <div class="col-8 treasure_island_expired">
        </div>
        <div class="col-2 cloud-r">
          <span class="waves wave2"></span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 alternative_flow_expired-headline">
          <h1>{{ getTranslations.visitor_alternative_expired_oh_no }}</h1>
          <p>{{ getTranslations.visitor_alternative_expired_it_seems }}</p>
        </div>
        <div class="col-12 alternative_flow_expired_lower_lead">
          <p>{{ getTranslations.visitor_alternative_every_time_you }}</p>
        </div>
        <div class="col-12 center">
          <img class="alternative_flow_prizes_image" src="static/images/alternative_flow/prizes-registration.svg" />
        </div>
        <div class="col-12 alternative_flow_expired_lower_lead">
          <p>{{ getTranslations.visitor_alternative_login_to_your }}</p>
        </div>
      </div>
      <div class="row center getstarted-ctas">
        <div class="col-md-12">
          <a class="ti_btn--green" style="cursor:pointer"
             @click.prevent="redirect('login')">{{ getTranslations.visitor_visitor_header_login }}</a>
        </div>
        <div class="col-md-12">
          <a class="ti_btn--white" style="cursor:pointer"
             @click.prevent="redirect('register')">{{ getTranslations.visitor_visitor_header_register }}</a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'expired-link',
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave: Winners');
    this.validTransitionForFreeGameMethod(false);
    next();
  },
  created() {
    console.log('in Expired Link created hook');
  },
  methods: {
    ...mapMutations('common', [
      'validTransitionForFreeGameMethod',
    ]),
    redirect(path) {
      if (path === 'login') this.$router.push('/login');
      else this.$router.push('/alternativetwostepregister1');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeGameProcess/ExpiredLink.vue